import { Box, VStack, Text, Stack, FormLabel, Input, Image, FormControl, Textarea } from '@chakra-ui/react';
import React from 'react';
import { IMG } from '../../../Content/Content';

const AddProducts = () => {
    const Products =[
        {
            ImageUrl:IMG.Product1,
        },
        {
            ImageUrl:IMG.Product2,
        },
        {
            ImageUrl:IMG.product3,
        },
        {
            ImageUrl:IMG.Product4,
        },
        {
            ImageUrl:IMG.Product5,
        },
        {
            ImageUrl:IMG.Product6,
        },

    ]
    return (
        <VStack w="100%" >
            <Box textAlign="left" w="100%" paddingTop="40px">
                <Text
                    fontSize="30px"
                    fontWeight="500"
                    color="rgba(0, 0, 0, 0.84)"
                    position="relative" className='Title_product' paddingLeft="20px" _before={{
                        position: "absolute",
                        left: "0",
                        right: "0",
                        height: "100%",
                        background: " linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)",
                        width: "9px"
                    }}>Add Products</Text>
            </Box>

            {/* form */}
            <Stack paddingY="40px" flexDirection="row" w="100%" paddingLeft="20px">
                <Box w="50%">
                    <FormControl marginBottom="10px" paddingRight="10px" w="70%">
                        <FormLabel htmlFor='productName' fontSize="18px" fontWeight="500" marginBottom="10px">
                            Enter Product Name
                        </FormLabel>
                        <Input name="productName" type="text" id="productName"
                            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                            borderRadius="10px"
                            bg="#F5F5F5"
                        />
                    </FormControl>

                    <FormControl marginBottom="10px" paddingRight="10px" w="70%">
                        <FormLabel htmlFor='productClass' fontSize="18px" fontWeight="500" marginBottom="10px">
                            Enter Product Class
                        </FormLabel>
                        <Input name="productClass" type="text" id="productClass"
                            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                            borderRadius="10px"
                            bg="#F5F5F5"
                        />
                    </FormControl>
                </Box>
                <Box w="50%" marginTop="0 !important">
                    <FormControl marginBottom="10px" paddingRight="10px" w="100%">
                        <FormLabel htmlFor='productWrite' fontSize="18px" fontWeight="500" marginBottom="10px">
                            Product Write Up
                        </FormLabel>
                        <Textarea name="productWrite"  id="productWrite"
                            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                            borderRadius="10px"
                            bg="#F5F5F5"
                        ></Textarea>
                    </FormControl>
                </Box>
            </Stack>
            {/* add Product */}

            <Stack paddingY="40px" flexDirection="row" flexWrap="wrap" w="100%" alignItems="start" justifyContent={'start'}>

                <Box w="33%" marginTop="10px">
                    <Box position="relative" w="100%" display="flex" alignItems="center" padding="20px" justifyContent="center" overflow="hidden">
                        <Box h="300" w="100%" bg="#F5F5F5" boxShadow=" 0px 4px 4px rgba(0, 0, 0, 0.25)"
                            display="flex" alignItems="center" justifyContent="center">
                            <FormLabel display="flex">
                                <Input type="file" display="none" />
                                <Text paddingRight="10px">Upload image</Text> <Image src={IMG.UploadImage} />
                            </FormLabel>
                        </Box>

                    </Box>
                </Box>

                   {
                    Products.map(product =>(
                        <Box w="33%">
                        <Box position="relative" w="100%" display="flex" flexDirection="column" alignItems="center" padding="20px" justifyContent="center" overflow="hidden">
                            <Box h="300" w="100%" bg="#F5F5F5" boxShadow=" 0px 4px 4px rgba(0, 0, 0, 0.25)"
                                display="flex" alignItems="center" justifyContent="center">
                                <Image src={product.ImageUrl} w="100%" objectFit={'cover'} h="100%"></Image>
                            </Box>
                            {/* <Text fontSize="24px" paddingY="10px" fontWeight="400" color="rgba(0, 0, 0, 0.84)">
                                Product name
                            </Text> */}
    
                        </Box>
                    </Box>
                    ))
                   } 




            </Stack>
        </VStack>
    );
};

export default AddProducts;